import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { selectedInstrumentSelector } from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { dateFilter } from 'apex-web/lib/helpers/orderHistoryFilters';
import get from 'lodash/get';

const formSelector = formValueSelector('order-history-filter');
const products = state => state.apexCore.product.products;
const depositProductId = state => state.deposit.product;
const withdrawProductId = state => state.withdraw.ProductId;
const verificationLevelConfigsProducts = state =>
  get(state, ['user', 'verificationLevelConfigs', 'Products'], []);

export const productsListSelector = createSelector(
  state => state.apexCore.product.products,
  products =>
    products.map(({ Product, ProductFullName, ProductId, DecimalPlaces }) => ({
      Product,
      ProductFullName,
      ProductId,
      DecimalPlaces
    }))
);

export const filteredDepositsByProductSelector = createSelector(
  [
    selectedInstrumentSelector,
    state => state.deposit.depositsStatus,
    state => state.apexCore.position.selectedProductId,
    state => formSelector(state, 'startDate', 'endDate'),
    (state, props) => props.filterMode
  ],
  (instrument, deposits, selectedProductId, formValues, filterMode) => {
    if (filterMode === 'selectedProduct') {
      return (
        deposits
          // .filter(
          //   deposit =>
          //     selectedProductId ? deposit.AssetId === selectedProductId : true
          // )
          .filter(deposit =>
            dateFilter(
              deposit,
              formValues.startDate,
              formValues.endDate,
              'CreatedTimestamp'
            )
          )
          .sort(
            (a, b) =>
              new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp)
          )
      );
    } else {
      return (
        deposits
          // .filter(
          //   deposit =>
          //     deposit.AssetId === instrument.Product1 ||
          //     deposit.AssetId === instrument.Product2
          // )
          .sort(
            (a, b) =>
              new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp)
          )
      );
    }
  }
);

export const filteredWithdrawalsByProductSelector = createSelector(
  [
    selectedInstrumentSelector,
    state => state.withdraw.withdrawTickets,
    state => state.apexCore.position.selectedProductId,
    state => formSelector(state, 'startDate', 'endDate'),
    (state, props) => props.filterMode
  ],
  (instrument, withdrawals, selectedProductId, formValues, filterMode) => {
    if (filterMode === 'selectedProduct') {
      return (
        withdrawals
          // .filter(
          //   withdrawal =>
          //     selectedProductId ? withdrawal.AssetId === selectedProductId : true
          // )
          .filter(withdrawal =>
            dateFilter(
              withdrawal,
              formValues.startDate,
              formValues.endDate,
              'CreatedTimestamp'
            )
          )
          .sort(
            (a, b) =>
              new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp)
          )
      );
    } else {
      return (
        withdrawals
          // .filter(
          //   withdrawal =>
          //     withdrawal.AssetId === instrument.Product1 ||
          //     withdrawal.AssetId === instrument.Product2
          // )
          .sort(
            (a, b) =>
              new Date(b.CreatedTimestamp) - new Date(a.CreatedTimestamp)
          )
      );
    }
  }
);

export const depositProductSelector = createSelector(
  [products, depositProductId],
  (products, depositProductId) =>
    products.find(prod => prod.ProductId === depositProductId)
);

export const withdrawProductSelector = createSelector(
  [products, withdrawProductId],
  (products, withdrawProductId) =>
    products.find(prod => prod.ProductId === withdrawProductId)
);

export const depositAddressSelector = createSelector(
  state => state.deposit,
  deposit => {
    const { depositInfo: addressList, isLoading } = deposit;
    let selectedAddress;
    if (!isLoading && addressList.length) {
      selectedAddress = addressList[addressList.length - 1];
    }

    return selectedAddress;
  }
);

export const whiteListedAddressesSelector = createSelector(
  state => state.user.selectedAccountId,
  state => state.apexCore.position.selectedProductId,
  state => state.eotcWithdraw.withdrawInfos,
  (selectedAccountId, selectedProductId, withdrawInfos) =>
    withdrawInfos.filter(
      ({ AccountId, ProductId }) =>
        AccountId === selectedAccountId && ProductId === selectedProductId
    )
);

export const productDepositLimitsSelector = createSelector(
  [products, depositProductId, verificationLevelConfigsProducts],
  (products, depositProductId, verificationLevelConfigsProducts) => {
    const product = products.find(prod => prod.ProductId === depositProductId);
    const verificationLevelConfigsProduct =
      product &&
      verificationLevelConfigsProducts.find(
        VerificationLevelConfigsProduct =>
          VerificationLevelConfigsProduct.ProductId === product.ProductId
      );

    return verificationLevelConfigsProduct;
  }
);

export const productWithdrawLimitsSelector = createSelector(
  [products, withdrawProductId, verificationLevelConfigsProducts],
  (products, withdrawProductId, verificationLevelConfigsProducts) => {
    const product = products.find(prod => prod.ProductId === withdrawProductId);

    const verificationLevelConfigsProduct =
      product &&
      verificationLevelConfigsProducts.find(
        VerificationLevelConfigsProduct =>
          VerificationLevelConfigsProduct.ProductId === product.ProductId
      );

    return verificationLevelConfigsProduct;
  }
);
